import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import HomeSection from './HomeSection';
import type { HomeUpcomingEvent } from './homeTypes';

interface UpcomingHomeEventsProps {
  events: HomeUpcomingEvent[];
}

export const UpcomingHomeEvents: React.FC<UpcomingHomeEventsProps> = ({ events }) => {
  const navigate = useNavigate();
  const list = events.slice(0, 4);
  if (!list.length) return null;

  return (
    <HomeSection
      title="Your upcoming events"
      description="Events you registered for, organize, or judge."
      action={
        <Button type="button" variant="ghost" size="sm" onClick={() => navigate('/events')}>
          All events
        </Button>
      }
    >
      <ul className="space-y-3">
        {list.map((evt) => {
          const href = evt.href || `/events/${evt.slug}`;
          return (
            <li key={evt.id}>
              <button
                type="button"
                onClick={() => navigate(href)}
                className="w-full text-left flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 border border-white/[0.06] bg-[#0c0c0c]/70 px-4 py-3 hover:border-white/[0.12] cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400"
              >
                <div className="min-w-0 flex-1">
                  <p className="text-white font-medium truncate">{evt.title}</p>
                  <p className="text-gray-500 text-xs sm:text-sm mt-0.5">
                    {[evt.location_label, evt.starts_at ? new Date(evt.starts_at).toLocaleDateString() : null]
                      .filter(Boolean)
                      .join(' · ')}
                  </p>
                </div>
                {evt.role ? (
                  <span className="text-[11px] uppercase tracking-wide text-gray-400 border border-white/[0.08] px-2 py-0.5 self-start">
                    {evt.role}
                  </span>
                ) : null}
              </button>
            </li>
          );
        })}
      </ul>
    </HomeSection>
  );
};

export default UpcomingHomeEvents;
